export const STRATEGY_STORE_KEY = "strategy-store" as const;
